import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import {
  parseCsvCalendarDate,
  parseCsvLocalDateTime,
} from '~/prix/utils/bulk/csvValueParsers'

const attendance: Dataset = {
  schema: 'public_health',
  table: 'attendance',
  columnTransformMap: {
    original_id: original => original,
    data_source_id: original => original,
    citizen_original_id: original => original,
    citizen_cpf: original => original,
    citizen_cns: original => original,
    professional_cns: original => original,
    professional_cbo: original => original,
    health_unit_cnes: original => original,
    team_ine: original => original,
    attendance_date_time: original => parseCsvLocalDateTime(original as string),
    type_of_attendance: original => original,
    weight: original => original,
    height: original => original,
    is_vaccination_up_to_date: original => (original === 'true' ? true : false),
    last_menstruation_date: original => parseCsvCalendarDate(original as string),
    is_observation: original => (original === 'true' ? true : false),
    is_schedule_return: original => (original === 'true' ? true : false),
    is_schedule_for_groups: original => (original === 'true' ? true : false),
    is_schedule_for_nasf: original => (original === 'true' ? true : false),
    is_schedule_for_continued_care: original => (original === 'true' ? true : false),
    is_episode_discharge: original => (original === 'true' ? true : false),
    has_referral_to_specialized_service: original => (original === 'true' ? true : false),
    has_referral_to_caps: original => (original === 'true' ? true : false),
    has_referral_to_hospitalization: original => (original === 'true' ? true : false),
    has_referral_to_urgency: original => (original === 'true' ? true : false),
    has_referral_to_home_care_service: original => (original === 'true' ? true : false),
    has_intersectoral_referral: original => (original === 'true' ? true : false),
    created_at: original => parseCsvLocalDateTime(original as string),
    updated_at: original => parseCsvLocalDateTime(original as string),
  },
}

export default attendance
